import { StoreService } from './../../../services/store.service';
import { ApiService } from './../../../services/api.service';
import { Profil } from './../../../models/Profil';
import { CommandeService } from './../../../services/commande.service';
import { Component, OnInit } from '@angular/core';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-vente',
  templateUrl: './vente.component.html',
  styleUrls: ['./vente.component.css']
})
export class VenteComponent implements OnInit {

  titre = 'Ventes';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  listRegroupment: SelectItem[] = [];
  listLocalite: SelectItem[] = [];

  constructor(private confirmationService: ConfirmationService, private commandeService: CommandeService,
    private store: StoreService) { }

  ngOnInit() {
    this.loadSelectList();
    this.initChartBarre();
    this.initChartPie();
  }


  initChartBarre() {
    this.dataBar = {
      labels: ['Sabalibougou', 'Kalaban coro', 'Maganbougou', 'Hamdalaye', 'Bamako coura', 'ACI200', 'Kalaban coura', 'Sebenicore', 'Sabalibougou', 'Hamdalaye', 'Faladie', 'Sebenicore'],
      datasets: [
          {
              label: 'Vente Zone',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [650000, 590000, 800000, 810000, 560000, 550000, 280000, 480000, 400000, 190000, 860000, 270000]
          },
          {
            label: 'Vente Hors Zone',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            data: [600000, 630000, 700000, 800000, 460000, 450000, 380000, 580000, 300000, 300000, 960000, 200000]
        }
      ]
    };

  }

  initChartPie() {
      this.dataPie = {
        labels: ['ZONE','HORS_ZONE'],
        datasets: [
            {
                data: [500000, 300000],
                backgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ],
                hoverBackgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ]
            }]
        };
    }


    loadSelectList() {
      this.listMsisdn = [];
      this.listMsisdn.push({ label: 'Msisdn...', value: null });
      this.listMsisdn.push({ label: '77888800', value: '77888800' });
      this.listMsisdn.push({ label: '77888801', value: '77888801' });
      this.listMsisdn.push({ label: '77888802', value: '77888802' });

      this.listLogin = [];
      this.listLogin.push({ label: 'PDG...', value: null });
      this.listLogin.push({ label: 'cie0001 - CIE Partenaire', value: 'cie0001 - CIE Partenaire' });
      this.listLogin.push({ label: 'tech0001 - Global tech', value: 'tech0001 - Global tech' });

      this.listRegroupment = [];
      this.listRegroupment.push({ label: 'Niveau...', value: null });
      this.listRegroupment.push({ label: 'DZ', value: 'DZ' });
      this.listRegroupment.push({ label: 'Sous Zone', value: 'Sous Zone' });
      this.listRegroupment.push({ label: 'Secteur', value: 'Secteur' });

      this.listLocalite = [];
      this.listLocalite.push({ label: 'Localite...', value: null });    
      
    }

    exporter(){
      
    }
}
